import { Controller } from 'stimulus'
import Rails from '@rails/ujs'
import { set } from 'lodash'

export default class extends Controller {

  connect() {
    console.log(44)
    setTimeout(() => {
      var event = new MouseEvent('mousedown');
      this.element.size = this.element.length
      // Rails.fire(this.element, 'click')
    }, 300)

    // this.element.dispatchEvent(new Event('mousedown'));
    // this.element.dispatchEvent(new Event('mouseup'));    // var event = document.createEvent('MouseEvents')
    // event.initMouseEvent('mousedown', true, true, window)
    // this.element.dispatchEvent(event)
  }
}
